import EmployeeSalarySalaryComponents from "../components/EmployeeSalarySalary";
import useEmployeeSalarySalary from "../hooks/useEmployeeSalarySalary";

function EmployeeSalarySalary() {
  const employeeSalarySalaryProps = useEmployeeSalarySalary();
  return <EmployeeSalarySalaryComponents {...employeeSalarySalaryProps} />;
}

export default EmployeeSalarySalary;
